import Input from "../Input/Input";
import React from "react";
import SpecificDates from "./utilsValues/specificDates";

export const getUtilValues = ({ selectedUtil, handleChangeValue, selectedValue = '' }) => {
  switch (selectedUtil?.value) {
    case "specificDates":
      return <SpecificDates handleChangeValue={handleChangeValue} selectedValue={selectedValue}/>;
    default:
      return (
        <Input
          placeholder="Enter some value"
          width="w-full min-w-[235px]"
          classes="h-[56px] mt-[6px]"
          value={selectedValue}
          onChange={(event) => handleChangeValue(event?.target?.value)}
        />
      );
  }
};